import './SingleValueDisplayReport.css';
import { t } from 'i18next';
import { connect } from 'react-redux';
import React from 'react';
import Loading from '../../loading/Loading';
import { stringToNumberLocale } from '../../../helpers/formatter';
import ChartReport from '../ChartReport';

const SingleValueDisplayReport = ({
  title, width = 'auto', height = 'auto', data,
  inputRequired = false, helperMsg = '',
}) => (
  <div className="SingleValueDisplayReport report nodata"
    style={{
      height: `${height}px`,
      width: `${width}px`,
    }}
  >
    <h2>{t(title)}</h2>
    {inputRequired
      ? ChartReport.helperMsg(width, height, helperMsg)
      : (
        <div>
          {! data ? <Loading size={40} />
            : (
              <div className="displayValue">
                {stringToNumberLocale(data)}
              </div>
            )
          }
        </div>
      )
  }
  </div>
);
export default connect()(SingleValueDisplayReport);
